module.exports = __webpack_public_path__ + "static/media/vis5.8b6c94ca.jpeg";